import { useState, useRef } from "react";
import { Card, CardBody, CardText, Form, Row, Col } from "reactstrap";
// drop
import Dropzone from "react-dropzone";
// componentes
import ModeloUpload from "../../../assets/statics/modelo_transfer_atualizar.xlsx";
import ModalExcelRows from "../Voo/ModalExcelRows";
// utils
import readXlsxFile from "read-excel-file";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
// validadores
import {
  allExcelColumnsUpdate,
  getValidTransfers,
  excelColumnsPtBrUpdate,
} from "./importTransferValidation";
import { findRowsWithError } from "./importValidation";
// service
import { updateTransferImport } from "../../../utils/services/transfer";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";

export default function ImportUpdateTransfer(props) {
  const { toggleModal, idEvent, data } = props;
  // arquivos selecionados e envio
  const [selectedFiles, setselectedFiles] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  // botoes
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  // erros e alerta
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState(false);
  const [success_dlg, setsuccess_dlg] = useState(false);
  // importando
  const importActivated = useRef(false);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;

    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      IdTransfer: {
        prop: "id",
        type: String,
      },
      Participante: {
        prop: "login",
        type: String,
      },
      Empresa: {
        prop: "company",
        type: String,
      },
      Origem: {
        prop: "origin",
        type: String,
      },
      Destino: {
        prop: "destination",
        type: String,
      },
      DataEmbarque: {
        prop: "boardingdate",
        type: String,
      },
      HoraEmbarque: {
        prop: "boardingtill",
        type: String,
      },
      DataChegada: {
        prop: "arrivaldate",
        type: String,
      },
      HoraChegada: {
        prop: "arrivaltime",
        type: String,
      },
      PontoDeEncontro: {
        prop: "meetingpoint",
        type: String,
      },
      NomeDoMotorista: {
        prop: "drivername",
        type: String,
      },
      TelefoneDoMotorista: {
        prop: "driverphone",
        type: String,
      },
      InformacoesExtras: {
        prop: "extrainformation",
        type: String,
      },
    };

    let count = 1;

    const readXlsx = async () => {
      const { rows } = await readXlsxFile(selectedFiles[0], { schema });
      const validateRows = rows.map((row, i) => allExcelColumnsUpdate(row, i));

      setTotalRows(validateRows?.length);

      // validar colunas se esta no padrão
      const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
      const header = rowsWithoutSchema[0];
      const schemaCreate = Object.keys(schema);

      function isEqual(schema, header) {
        if (schema.length !== header.length) return false;

        return (
          schema.every((item) => header.includes(item)) &&
          header.every((item) => schema.includes(item))
        );
      }

      if (!isEqual(schemaCreate, header)) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      // validar campos vazios
      const rowsWithError = findRowsWithError(validateRows);

      if (rowsWithError.length > 0 || rows.length === 0) {
        setErrors(rowsWithError);
        setModalErrors(true);
        return;
      }

      // validar se todos objetos estão cadastrados para poderem ser atualizados
      const validsTransfers = await getValidTransfers({
        transfers: validateRows,
        idEvent,
        isUpdate: true,
      });

      if (validsTransfers?.length > 0) {
        setErrors(validsTransfers);
        setModalErrors(true);
        return;
      }

      for (const row of validateRows) {
        await updateTransferImportFunc(row, validateRows.length);
      }
    };

    readXlsx();

    async function updateTransferImportFunc(row, totalRows) {
      const dataRow = {
        event: idEvent,
        login: row.login,
        company: row.company,
        origin: row.origin,
        destination: row.destination,
        boardingdate: row.boardingdate
          ? row.boardingdate.replaceAll("/", "-")
          : null,
        arrivaldate: row.arrivaldate
          ? row.arrivaldate.replaceAll("/", "-")
          : null,
        boardingtill: row.boardingtill,
        arrivaltime: row.arrivaltime,
        meetingpoint: row.meetingpoint,
        drivername: row.drivername,
        driverphone: row.driverphone,
        extrainformation: row.extrainformation,
        id: row.id,
      };

      await updateTransferImport(dataRow)
        .then((res) => {
          if (res.message === "updated") {
            count++;
            setTotalSended(count);
          }

          if (count === totalRows || (count === 2 && totalRows === 1)) {
            setsuccess_dlg(true);
          }
        })
        .catch((error) => console.log("erro", error));
    }
  }

  return (
    <>
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBrUpdate}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            data[0]?.refetch();
            data[1]?.refetch();
            toggleModal();
            setsuccess_dlg(false);
          }}
        >
          {"Os Transfers foram atualizados com sucesso!"}
        </SweetAlert>
      ) : null}

      <Card className="p-1">
        <CardBody className="m-1 p-2">
          <CardText className="mb-2 p-10">
            O arquivo a ser importado deve seguir este{" "}
            <a href={ModeloUpload} download="modelo_transfer_atualizar.xlsx">
              Modelo
            </a>
            , não modifique seu cabeçalho.
          </CardText>

          <Form>
            {selectedFiles.length === 0 && (
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-1"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-4">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                        <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}
            <div className="dropzone-previews mt-0" id="file-previews">
              {selectedFiles.map((f, i) => {
                return (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + "-file"}
                  >
                    <div className="p-1">
                      <Row className="align-items-center">
                        <Col xs="11">
                          <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                        </Col>
                        <Col xs="1">
                          <span
                            style={{
                              fontSize: "16px",
                              color: "red",
                              fontWeight: "700",
                            }}
                            className="mdi mdi-close"
                            onClick={() => setselectedFiles([])}
                          />
                        </Col>
                      </Row>
                      {importActivated.current && (
                        <Row className="align-items-center">
                          <Col>
                            <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          </Form>

          <div className="text-center mt-3">
            <button
              type="button"
              disabled={!btnSend}
              className="btn btn-primary waves-effect waves-light"
              onClick={() => uploadService()}
            >
              Atualizar Tranfers
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={() => cancelImport()}
            >
              Cancelar
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
